import { Select } from '@/lib/Selects';
import { SelectOption } from '@/lib/Selects/Select/';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type UnifiedProfileDetailsSectionItemProps = { label: string; options: string[] };

export const UnifiedProfileDetailsSectionItem: FC<UnifiedProfileDetailsSectionItemProps> = ({ label, options }) => {
  const { t } = useTranslation('unifiedProfile');

  const [value, setValue] = useState<SelectOption>({
    id: options?.[0] || '-',
    label: options?.[0] || '-',
  });

  const selectOptions = useMemo(
    () =>
      options?.map(
        (option) =>
          ({
            id: option,
            label: option,
          }) satisfies SelectOption
      ) ?? [],
    [options]
  );

  const title = t(label as any);

  return (
    <div className='flex w-full flex-wrap items-center justify-between gap-2'>
      <p title={title} className='truncate text-sm font-medium text-primary-900 first-letter:capitalize'>
        {title}
      </p>
      <Select
        classNames={{
          wrapper: 'w-full max-w-[75%] min-w-[280px]',
        }}
        value={value}
        items={selectOptions}
        onChange={setValue}
        disabled={value.id === '-'}
      />
    </div>
  );
};
